import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';

// External Libraries
import { MtxButtonModule } from '@ng-matero/extensions/button';

// HTTP
import { HttpClientModule } from '@angular/common/http';
import { HttpInteceptorModule } from './http/http-interceptor.module';

// Library
import { MaterialsModule } from '@library/common';
import { PipesModule } from '@library/core/pipes';
import { AuthGuard } from '@library/modules/auth';
import { UserAccessGuard } from '@library/modules/user';

import { AmazingTimePickerModule } from '@jonijnm/amazing-time-picker';

// App Specific
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AppMenuModule } from './components/menu/menu.module';

@NgModule({
   declarations: [
      AppComponent,
   ],
   imports: [
      BrowserModule,
      BrowserAnimationsModule,
      RouterModule,
      FormsModule,
      ReactiveFormsModule,

      // External Libraries
      MtxButtonModule,

      // HTTP
      HttpClientModule,
      HttpInteceptorModule,

      // Library
      PipesModule,
      MaterialsModule,

      AmazingTimePickerModule,

      AppMenuModule,
      AppRoutingModule,
   ],
   providers: [
      // Guards
      UserAccessGuard,
      AuthGuard,

      Validators,
   ],
   bootstrap: [ AppComponent ]
})
export class AppModule { }
